(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[8],{

/***/ "6lYI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ ilab_footer; });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/e6t/lazy-image/index.jsx
var lazy_image = __webpack_require__("eM4/");

// EXTERNAL MODULE: ./__mock__/homeDatas.js
var homeDatas = __webpack_require__("p8IS");

// EXTERNAL MODULE: ./src/components/desktop/common/footer/ilab-footer/styles.module.scss
var styles_module = __webpack_require__("Wubn");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/common/footer/ilab-footer/ilab-footer.jsx
var __jsx = react_default.a.createElement;





var ilab_footer_IlabFooter = function IlabFooter() {
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear();
  return __jsx("div", {
    className: styles_module_default.a.ilabContainer
  }, __jsx("div", {
    className: styles_module_default.a.ilabWrapper
  }, __jsx("div", {
    className: styles_module_default.a.ilabContent
  }, __jsx("p", {
    className: styles_module_default.a.ilabTitle
  }, "Emlakjet bir "), __jsx("a", {
    className: styles_module_default.a.ilabLogo,
    href: "http://www.ilab.com.tr/",
    target: "_blank",
    rel: "nofollow noreferrer"
  }, __jsx(lazy_image["a" /* default */], {
    src: "/static/img/brands/ilab.png",
    alt: "iLab",
    width: 65,
    height: 23
  })), ' ', __jsx("p", {
    className: styles_module_default.a.ilabTitle
  }, "grup \u015Firketidir")), __jsx("div", {
    className: styles_module_default.a.ilabCompanies
  }, homeDatas["b" /* ilabCompanies */].map(function (company, index) {
    var href = company.href,
        src = company.src,
        width = company.width,
        height = company.height;
    var alt = src === null || src === void 0 ? void 0 : src.slice(19, -4);
    return __jsx("a", {
      href: href,
      target: "_blank",
      rel: "nofollow noreferrer",
      key: index
    }, __jsx(lazy_image["a" /* default */], {
      src: src,
      placeholder: "/static/img/1px-transparent.png",
      alt: "".concat(alt, ".com"),
      width: width,
      height: height
    }));
  })), __jsx("div", {
    className: styles_module_default.a.ilabDetail
  }, "Emlakjet.com \xA9 2006-", currentYear, ' ', "Emlakjet.com sitesinde kullan\u0131c\u0131lar taraf\u0131ndan sa\u011Flanan her t\xFCrl\xFC ilan, bilgi, i\xE7erik ve g\xF6rselin ger\xE7ekli\u011Fi, orijinalli\u011Fi, g\xFCvenilirli\u011Fi ve do\u011Frulu\u011Funa ili\u015Fkin sorumluluk bu i\xE7erikleri giren kullan\u0131c\u0131ya ait olup, emlakjet.com'un bu hususlarla ilgili herhangi bir sorumlulu\u011Fu bulunmamaktad\u0131r.")));
};

/* harmony default export */ var ilab_footer = (ilab_footer_IlabFooter);
// CONCATENATED MODULE: ./src/components/desktop/common/footer/ilab-footer/index.js


/***/ }),

/***/ "Ohjr":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"_2NQFxP","footerContent":"_2Gic0a","footerMain":"_2yjZkG","footerList":"_25fh6R","headerTitle":"_2Vwl4C","footerButton":"_2ejkVv"};

/***/ }),

/***/ "PhnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ footer; });

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./src/redux-store/containers/auth/index.js + 11 modules
var auth = __webpack_require__("lDfJ");

// EXTERNAL MODULE: ./services/panelService.js
var panelService = __webpack_require__("D9O2");

// EXTERNAL MODULE: ./src/utils/url/index.js
var utils_url = __webpack_require__("Onhb");

// EXTERNAL MODULE: ./src/helpers/notifier/component/index.jsx
var component = __webpack_require__("bkYj");

// EXTERNAL MODULE: ./src/components/desktop/contracts/index.jsx + 1 modules
var contracts = __webpack_require__("8Xu1");

// EXTERNAL MODULE: ./src/components/desktop/contracts/contents.js + 10 modules
var contents = __webpack_require__("TvSa");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/desktop/common/footer/styles.module.scss
var styles_module = __webpack_require__("Ohjr");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/common/footer/footer.jsx









var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }












var footerListData = [{
  title: 'Emlakjet',
  children: [{
    name: 'Hakkımızda',
    href: '/hakkimizda',
    testSelector: 'footer-about-us'
  }, {
    name: 'Ödüllerimiz',
    href: '/odullerimiz',
    testSelector: 'footer-awards'
  }, {
    name: 'Kurumsal Materyaller',
    href: '/kurumsal-materyaller',
    testSelector: 'footer-corporate-materials'
  }, {
    name: 'Reklam',
    href: '/reklam',
    testSelector: 'footer-advertisement'
  }, {
    name: 'İnsan Kaynakları',
    href: '/insan-kaynaklari',
    testSelector: 'footer-human-resources'
  }, {
    name: 'Site Haritası',
    href: '/site-haritasi',
    testSelector: 'footer-sitemap'
  }]
}, {
  title: 'Hizmetlerimiz',
  children: [{
    name: 'Size Özel Hizmetlerimiz',
    href: '/hizmetler/hizmetlerimiz'
  }, {
    name: 'Emlak Haberleri',
    href: '/haber'
  }, {
    name: 'Kurumsal Üyelik',
    href: '/uye-ol/kurumsal'
  }, {
    name: 'Projeler',
    href: '/satilik-konut/projeler'
  }, {
    name: 'Ücretsiz ilan Ver',
    href: '/'
  } // {
  //   name: 'Jettaşın',
  //   href: '/jettasin/',
  // },
  // İs bankasi comment line
  // {
  //   name: 'Konut Kredisi Hesaplama',
  //   href: '/hizmetlerimiz/isbankasi-konut-kredisi',
  // },
  // {
  //   name: 'Konut Kredisi Hesaplama',
  //   href: '/hizmetlerimiz/akbank-konut-kredisi/',
  // },
  ]
}, {
  title: 'Diğer',
  children: Object.values(contents["a" /* default */])
}];

var footer_Footer = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(Footer, _React$Component);

  var _super = _createSuper(Footer);

  function Footer() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      selectedContract: null
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "footerListItemRender", function (children) {
      return children.map(function (child, index) {
        if (child.name === 'Ücretsiz ilan Ver') {
          return (// eslint-disable-next-line react/no-array-index-key
            __jsx("span", {
              key: child.name + index,
              onClick: _this.handleNewListingLink
            }, child.name)
          );
        }

        return (// eslint-disable-next-line react/no-array-index-key
          __jsx("a", {
            key: child.name + index,
            href: child.href,
            "data-test-selector": child.testSelector
          }, child.name)
        );
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "setContract", function (contract) {
      _this.setState({
        selectedContract: contract.key
      });

      window.history.replaceState('Sözleşmeler ve Koşullar', 'Title', Object(utils_url["a" /* addAnchorToUrl */])(window.location.href, contract.anchor));
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleContractModalClose", function () {
      return _this.setState({
        selectedContract: null
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "contractListItemRender", function (children) {
      return children.map(function (item) {
        var _classnames;

        var isEfilliCookie = item.key === 'cookieManagement';
        var isEfilliCookieClasses = classnames_default()((_classnames = {}, Object(defineProperty["default"])(_classnames, styles_module_default.a.footerButton, !isEfilliCookie), Object(defineProperty["default"])(_classnames, 'efl-edit', isEfilliCookie), _classnames));
        return item.key !== 'employeeCandidateDisclosureEn' && __jsx("span", Object(esm_extends["a" /* default */])({}, !isEfilliCookie && {
          onClick: function onClick() {
            return _this.setContract(item);
          }
        }, {
          className: isEfilliCookieClasses,
          key: item.key
        }), item.title);
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "handleNewListingLink", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          toggleSignupForm = _this$props.toggleSignupForm,
          isAuth = _this$props.isAuth;

      if (isAuth) {
        panelService["a" /* default */].redirectToPanel();
      } else {
        toggleSignupForm();
      }
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "footerListRender", function () {
      return footerListData.map(function (data) {
        return (// eslint-disable-next-line react/no-array-index-key
          __jsx("div", {
            key: data.title,
            className: styles_module_default.a.footerList
          }, __jsx("div", {
            className: styles_module_default.a.headerTitle
          }, data.title), data.title === 'Diğer' ? _this.contractListItemRender(data.children) : _this.footerListItemRender(data.children))
        );
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(Footer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var url = window.location.href;
      var urlParts = url.split('#');
      var anchorPart = null;

      if (urlParts.length > 1) {
        anchorPart = urlParts[1];
        var selectedContract = Object.values(contents["a" /* default */]).find(function (contract) {
          return contract.anchor === anchorPart;
        });

        if (selectedContract) {
          this.setState({
            selectedContract: selectedContract.key
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var selectedContract = this.state.selectedContract;
      return __jsx("div", {
        className: styles_module_default.a.footerContainer
      }, __jsx(contracts["a" /* default */], {
        isOpen: !!selectedContract,
        staticContentKey: selectedContract,
        onClose: this.handleContractModalClose
      }), __jsx("div", {
        className: styles_module_default.a.footerContent
      }, __jsx("div", {
        className: styles_module_default.a.footerMain
      }, this.footerListRender(), __jsx("div", {
        className: styles_module_default.a.footerList,
        style: {
          justifyContent: 'space-between'
        }
      }, __jsx("div", {
        className: styles_module_default.a.headerTitle
      }, "\u0130leti\u015Fim"), __jsx(desktop_elements["b" /* Button */], {
        secondary: true,
        style: {
          width: 280,
          margin: '8px 0 20px 0'
        }
      }, "0 850 312 73 73"), __jsx(desktop_elements["b" /* Button */], {
        secondary: true,
        style: {
          width: 280,
          marginBottom: 20
        },
        onClick: function onClick() {
          return window.location = '/iletisim';
        }
      }, "Mesaj G\xF6nder"), __jsx(desktop_elements["b" /* Button */], {
        secondary: true,
        style: {
          width: 280
        },
        onClick: function onClick() {
          return window.location = '/iletisim';
        }
      }, "\u0130leti\u015Fim Bilgileri")))), __jsx(component["a" /* default */], null));
    }
  }]);

  return Footer;
}(react_default.a.Component);

/* harmony default export */ var footer = (es["b" /* connect */].apply(void 0, Object(toConsumableArray["a" /* default */])(auth["a" /* default */]))(footer_Footer));
// CONCATENATED MODULE: ./src/components/desktop/common/footer/index.js


/***/ }),

/***/ "V+Py":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__("UbMB");
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);

// EXTERNAL MODULE: ./src/components/desktop/common/footer/footer-categories/styles.module.scss
var styles_module = __webpack_require__("VrER");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/common/footer/footer-categories/categories.js
var categories_categories = [{
  id: 1,
  name: 'Satılık',
  subCategories: [{
    title: 'Genel',
    children: [{
      name: 'Satılık Daire',
      href: '/satilik-daire'
    }, {
      name: 'Satılık İşyeri',
      href: '/satilik-isyeri'
    }, {
      name: 'Satılık Arsa',
      href: '/satilik-arsa'
    }, {
      name: 'Satılık Turistik Tesis',
      href: '/satilik-turistik-tesis'
    }, {
      name: 'Satılık Konut',
      href: '/satilik-konut'
    }]
  }, {
    title: 'Daire',
    children: [{
      name: 'İstanbul Satılık Daire',
      href: '/satilik-daire/istanbul'
    }, {
      name: 'Ankara Satılık Daire',
      href: '/satilik-daire/ankara'
    }, {
      name: 'İzmir Satılık Daire',
      href: '/satilik-daire/izmir'
    }, {
      name: 'Bursa Satılık Daire',
      href: '/satilik-daire/bursa'
    }, {
      name: 'Antalya Satılık Daire',
      href: '/satilik-daire/antalya'
    }]
  }, {
    title: 'İşyeri',
    children: [{
      name: 'İstanbul Satılık İşyeri',
      href: '/satilik-isyeri/istanbul'
    }, {
      name: 'Ankara Satılık İşyeri',
      href: '/satilik-isyeri/ankara'
    }, {
      name: 'İzmir Satılık İşyeri',
      href: '/satilik-isyeri/izmir'
    }, {
      name: 'Bursa Satılık İşyeri',
      href: '/satilik-isyeri/bursa'
    }, {
      name: 'Antalya Satılık İşyeri',
      href: '/satilik-isyeri/antalya'
    }]
  }, {
    title: 'Arsa',
    children: [{
      name: 'İstanbul Satılık Arsa',
      href: '/satilik-arsa/istanbul'
    }, {
      name: 'Ankara Satılık Arsa',
      href: '/satilik-arsa/ankara'
    }, {
      name: 'İzmir Satılık Arsa',
      href: '/satilik-arsa/izmir'
    }, {
      name: 'Bursa Satılık Arsa',
      href: '/satilik-arsa/bursa'
    }, {
      name: 'Antalya Satılık Arsa',
      href: '/satilik-arsa/antalya'
    }]
  }, {
    title: 'Konut Projeleri',
    children: [{
      name: 'Ankara Konut Projeleri',
      href: '/satilik-konut/ankara/projeler'
    }, {
      name: 'İstanbul Konut Projeleri',
      href: '/satilik-konut/istanbul/projeler'
    }, {
      name: 'İzmir Konut Projeleri',
      href: '/satilik-konut/izmir/projeler'
    }, {
      name: 'Antalya Konut Projeleri',
      href: '/satilik-konut/antalya/projeler'
    }, {
      name: 'Bursa Konut Projeleri',
      href: '/satilik-konut/bursa/projeler'
    }]
  }]
}, {
  id: 2,
  name: 'Kiralık',
  subCategories: [{
    title: 'Genel',
    children: [{
      name: 'Kiralık Daire',
      href: '/kiralik-daire'
    }, {
      name: 'Kiralık İşyeri',
      href: '/kiralik-isyeri'
    }, {
      name: 'Kiralık Arsa',
      href: '/kiralik-arsa'
    }, {
      name: 'Kiralık Turistik Tesis',
      href: '/kiralik-turistik-tesis'
    }, {
      name: 'Kiralık Konut',
      href: '/kiralik-konut'
    }]
  }, {
    title: 'Daire',
    children: [{
      name: 'İstanbul Kiralık Daire',
      href: '/kiralik-daire/istanbul'
    }, {
      name: 'Ankara Kiralık Daire',
      href: '/kiralik-daire/ankara'
    }, {
      name: 'İzmir Kiralık Daire',
      href: '/kiralik-daire/izmir'
    }, {
      name: 'Bursa Kiralık Daire',
      href: '/kiralik-daire/bursa'
    }, {
      name: 'Antalya Kiralık Daire',
      href: '/kiralik-daire/antalya'
    }]
  }, {
    title: 'İşyeri',
    children: [{
      name: 'İstanbul Kiralık İşyeri',
      href: '/kiralik-isyeri/istanbul'
    }, {
      name: 'Ankara Kiralık İşyeri',
      href: '/kiralik-isyeri/ankara'
    }, {
      name: 'İzmir Kiralık İşyeri',
      href: '/kiralik-isyeri/izmir'
    }, {
      name: 'Bursa Kiralık İşyeri',
      href: '/kiralik-isyeri/bursa'
    }, {
      name: 'Antalya Kiralık İşyeri',
      href: '/kiralik-isyeri/antalya'
    }]
  }, {
    title: 'Arsa',
    children: [{
      name: 'İstanbul Kiralık Arsa',
      href: '/kiralik-arsa/istanbul'
    }, {
      name: 'Ankara Kiralık Arsa',
      href: '/kiralik-arsa/ankara'
    }, {
      name: 'İzmir Kiralık Arsa',
      href: '/kiralik-arsa/izmir'
    }, {
      name: 'Bursa Kiralık Arsa',
      href: '/kiralik-arsa/bursa'
    }, {
      name: 'Antalya Kiralık Arsa',
      href: '/kiralik-arsa/antalya'
    }]
  }, {
    title: 'Günlük Kiralık',
    children: [{
      name: 'İstanbul Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/istanbul'
    }, {
      name: 'Ankara Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/ankara'
    }, {
      name: 'İzmir Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/izmir'
    }, {
      name: 'Antalya Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/antalya'
    }, {
      name: 'Mersin Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/mersin'
    }]
  }]
}, {
  id: 3,
  name: 'Sahibinden',
  subCategories: [{
    title: 'Genel',
    children: [{
      name: 'Sahibinden Satılık Daire',
      href: '/satilik-daire/sahibinden'
    }, {
      name: 'Sahibinden Satılık İşyeri',
      href: '/satilik-isyeri/sahibinden'
    }, {
      name: 'Sahibinden Satılık Arsa',
      href: '/satilik-arsa/sahibinden'
    }, {
      name: 'Sahibinden Satılık Turistik Tesis',
      href: '/satilik-turistik-tesis/sahibinden'
    }, {
      name: 'Sahibinden Satılık Konut',
      href: '/satilik-konut/sahibinden'
    }]
  }, {
    title: 'Daire',
    children: [{
      name: 'Sahibinden İstanbul Satılık Daire',
      href: '/satilik-daire/istanbul/sahibinden'
    }, {
      name: 'Sahibinden Ankara Satılık Daire',
      href: '/satilik-daire/ankara/sahibinden'
    }, {
      name: 'Sahibinden İzmir Satılık Daire',
      href: '/satilik-daire/izmir/sahibinden'
    }, {
      name: 'Sahibinden Bursa Satılık Daire',
      href: '/satilik-daire/bursa/sahibinden'
    }, {
      name: 'Sahibinden Antalya Satılık Daire',
      href: '/satilik-daire/antalya/sahibinden'
    }]
  }, {
    title: 'İşyeri',
    children: [{
      name: 'Sahibinden İstanbul Satılık İşyeri',
      href: '/satilik-isyeri/istanbul/sahibinden'
    }, {
      name: 'Sahibinden Ankara Satılık İşyeri',
      href: '/satilik-isyeri/ankara/sahibinden'
    }, {
      name: 'Sahibinden İzmir Satılık İşyeri',
      href: '/satilik-isyeri/izmir/sahibinden'
    }, {
      name: 'Sahibinden Bursa Satılık İşyeri',
      href: '/satilik-isyeri/bursa/sahibinden'
    }, {
      name: 'Sahibinden Antalya Satılık İşyeri',
      href: '/satilik-isyeri/antalya/sahibinden'
    }]
  }, {
    title: 'Arsa',
    children: [{
      name: 'Sahibinden İstanbul Satılık Arsa',
      href: '/satilik-arsa/istanbul/sahibinden'
    }, {
      name: 'Sahibinden Ankara Satılık Arsa',
      href: '/satilik-arsa/ankara/sahibinden'
    }, {
      name: 'Sahibinden İzmir Satılık Arsa',
      href: '/satilik-arsa/izmir/sahibinden'
    }, {
      name: 'Sahibinden Bursa Satılık Arsa',
      href: '/satilik-arsa/bursa/sahibinden'
    }, {
      name: 'Sahibinden Antalya Satılık Arsa',
      href: '/satilik-arsa/antalya/sahibinden'
    }]
  }, {
    title: 'Villa',
    children: [{
      name: 'Sahibinden Antalya Satılık Villa',
      href: '/satilik-villa/antalya/sahibinden'
    }, {
      name: 'Sahibinden İstanbul Satılık Villa',
      href: '/satilik-villa/istanbul/sahibinden'
    }, {
      name: 'Sahibinden Muğla Satılık Villa',
      href: '/satilik-villa/mugla/sahibinden'
    }, {
      name: 'Sahibinden İzmir Satılık Villa',
      href: '/satilik-villa/izmir/sahibinden'
    }, {
      name: 'Sahibinden Ankara Satılık Villa',
      href: '/satilik-villa/ankara/sahibinden'
    }]
  }]
}, {
  id: 4,
  name: 'Popüler',
  subCategories: [{
    children: [{
      name: 'Antalya Kiralık Daire',
      href: '/kiralik-daire/antalya'
    }, {
      name: 'Eskişehir Kiralık Daire',
      href: '/kiralik-daire/eskisehir'
    }, {
      name: 'Diyarbakır Kiralık Daire',
      href: '/kiralik-daire/diyarbakir'
    }, {
      name: 'Gaziantep Kiralık Daire',
      href: '/kiralik-daire/gaziantep'
    }, {
      name: 'Malatya Kiralık Daire',
      href: '/kiralik-daire/malatya'
    }, {
      name: 'Konya Kiralık Daire',
      href: '/kiralik-daire/konya'
    }]
  }, {
    children: [{
      name: 'Kiralık Villa',
      href: '/kiralik-villa'
    }, {
      name: 'Antalya Kiralık Villa',
      href: '/kiralik-villa/antalya'
    }, {
      name: 'Bodrum Kiralık Villa',
      href: '/kiralik-villa/mugla-bodrum'
    }, {
      name: 'Fethiye Kiralık Villa',
      href: '/kiralik-villa/mugla-fethiye'
    }, {
      name: 'Kaş Kiralık Villa',
      href: '/kiralik-villa/antalya-kas'
    }, {
      name: 'Mersin Kiralık Villa',
      href: '/kiralik-villa/mersin'
    }]
  }, {
    children: [{
      name: 'Satılık Villa',
      href: '/satilik-villa'
    }, {
      name: 'Kuşadası Satılık Villa',
      href: '/satilik-villa/aydin-kusadasi'
    }, {
      name: 'İzmir Satılık Villa',
      href: '/satilik-villa/izmir'
    }, {
      name: 'Muğla Satılık Villa',
      href: '/satilik-villa/mugla'
    }, {
      name: 'Ankara Satılık Villa',
      href: '/satilik-villa/ankara'
    }, {
      name: 'Urla Satılık Villa',
      href: '/satilik-villa/izmir-urla'
    }]
  }, {
    children: [{
      name: 'Gaziantep Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/gaziantep'
    }, {
      name: 'Bursa Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/bursa'
    }, {
      name: 'Samsun Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/samsun'
    }, {
      name: 'Adana Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/adana'
    }, {
      name: 'Eskişehir Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/eskisehir'
    }, {
      name: 'Balıkesir Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/balikesir'
    }]
  }, {
    children: [{
      name: 'Tekirdağ Satılık Arsa',
      href: '/satilik-arsa/tekirdag'
    }, {
      name: 'Balıkesir Satılık Arsa',
      href: '/satilik-arsa/balikesir'
    }, {
      name: 'Çanakkale Satılık Arsa',
      href: '/satilik-arsa/canakkale'
    }, {
      name: 'Kırklareli Satılık Arsa',
      href: '/satilik-arsa/kirklareli'
    }, {
      name: 'Sakarya Satılık Arsa',
      href: '/satilik-arsa/sakarya'
    }, {
      name: 'Kütahya Satılık Arsa',
      href: '/satilik-arsa/kutahya'
    }]
  }]
}];
/* harmony default export */ var footer_categories_categories = (categories_categories);
// CONCATENATED MODULE: ./src/components/desktop/common/footer/footer-categories/footer-categories.jsx







var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var footer_categories_FooterList = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(FooterList, _PureComponent);

  var _super = _createSuper(FooterList);

  function FooterList() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FooterList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      active: 1
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "renderSubCategoriesItem", function (children) {
      return children.map(function (child) {
        return __jsx("a", {
          key: child.name,
          href: child.href
        }, child.name);
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "renderSubCategories", function () {
      var active = _this.state.active;
      var filterCategory = footer_categories_categories.filter(function (item) {
        return item.id === active;
      });
      var _filterCategory$ = filterCategory[0],
          subCategories = _filterCategory$.subCategories,
          name = _filterCategory$.name;
      return subCategories.map(function (categories, index) {
        return __jsx("div", {
          key: categories.title,
          className: styles_module_default.a.categoriesSubCategories
        }, name !== 'Popüler' && __jsx("div", null, categories.title), _this.renderSubCategoriesItem(categories.children));
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "renderItem", function () {
      var active = _this.state.active;
      return footer_categories_categories.map(function (item) {
        var itemClassname = bind_default()(Object(defineProperty["default"])({}, styles_module_default.a.active, item.id === active));
        return __jsx("a", {
          key: item.id,
          className: itemClassname,
          onClick: _this.onChange.bind(Object(assertThisInitialized["a" /* default */])(_this), item.id)
        }, item.name);
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(FooterList, [{
    key: "onChange",
    value: function onChange(id) {
      this.setState({
        active: id
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __jsx("div", {
        className: styles_module_default.a.categoriesMain
      }, __jsx("div", {
        className: styles_module_default.a.categoriesContent
      }, __jsx("div", {
        className: styles_module_default.a.categoriesMenu
      }, this.renderItem()), __jsx("div", {
        className: styles_module_default.a.categoriesSubContent
      }, this.renderSubCategories())));
    }
  }]);

  return FooterList;
}(react["PureComponent"]);

/* harmony default export */ var footer_categories = __webpack_exports__["a"] = (footer_categories_FooterList);

/***/ }),

/***/ "VrER":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"categoriesMain":"_2sabUq","categoriesContent":"_3RygVw","categoriesMenu":"_32AGB9","active":"_1H6q1P","categoriesSubContent":"yBJ2ae","categoriesSubCategories":"_6Bx8pw"};

/***/ }),

/***/ "Wubn":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"ilabContainer":"_36tTcF","ilabWrapper":"_2U4D2M","ilabTitle":"_3ckJLF","ilabCompanies":"_2ZZafB","ilabDetail":"RjdATo","ilabContent":"_1USRnK","ilabLogo":"_3YphmV"};

/***/ }),

/***/ "p8IS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return socialBarIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return socialBarApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ilabCompanies; });
var featuredNewItems = [{
  slug: 'istanbul',
  img: '/static/img/content/city_istanbul.jpg',
  title: 'İstanbul',
  count: '120.000'
}, {
  slug: 'izmir',
  img: '/static/img/content/city_izmir.jpg',
  title: 'İzmir',
  count: '30.000'
}, {
  slug: 'ankara',
  img: '/static/img/content/city_ankara.jpg',
  title: 'Ankara',
  count: '40.000'
}, {
  slug: 'antalya',
  img: '/static/img/content/city_antalya.jpg',
  title: 'Antalya',
  count: '25.000'
}, {
  slug: 'aydin',
  img: '/static/img/content/city_aydin.jpg',
  title: 'Aydın',
  count: '20.000'
}, {
  slug: 'bursa',
  img: '/static/img/content/city_bursa.jpg',
  title: 'Bursa',
  count: '8.000'
}];
var socialBarIcons = [{
  href: 'https://www.facebook.com/Emlakjetcom/',
  src: '/static/icons/social/Facebook.svg',
  placeholder: '/static/img/1px-transparent.png'
}, {
  href: 'https://x.com/emlakjet',
  src: '/static/icons/social/Twitter.svg',
  placeholder: '/static/img/1px-transparent.png'
}, {
  href: 'https://www.instagram.com/emlakjet/',
  src: '/static/icons/social/Instagram.svg',
  placeholder: '/static/img/1px-transparent.png'
}, {
  href: 'https://tr.pinterest.com/emlakjet/',
  src: '/static/icons/social/Pinterest.svg',
  placeholder: '/static/img/1px-transparent.png'
}, {
  href: 'https://www.linkedin.com/company/emlakjet-com',
  src: '/static/icons/social/LinkedIn.svg',
  placeholder: '/static/img/1px-transparent.png'
}];
var socialBarApps = [{
  href: 'https://apps.apple.com/tr/app/emlakjet-emlak-ara-i-lan-ver/id1194656334?l=tr',
  src: '/static/icons/social/AppStore.svg',
  placeholder: '/static/img/1px-transparent.png',
  isSvgIcon: true
}, {
  href: 'https://play.google.com/store/apps/details?id=com.emlakjet.kurumsal.sekizbit',
  src: '/static/icons/social/GooglePlay.svg',
  placeholder: '/static/img/1px-transparent.png',
  isSvgIcon: true
}, {
  href: 'https://appgallery.huawei.com/app/C101850135',
  src: '/static/icons/social/AppGallery.svg',
  placeholder: '/static/img/1px-transparent.png',
  isSvgIcon: true
}];
var ilabCompanies = [{
  href: 'https://www.kariyer.net/',
  src: '/static/img/brands/kariyer.png',
  width: 85,
  height: 18
}, {
  href: 'https://www.sigortam.net/',
  src: '/static/img/brands/sigortam.png',
  width: 100,
  height: 18
}, {
  href: 'https://www.arabam.com/',
  src: '/static/img/brands/arabam.png',
  width: 80,
  height: 13
}, {
  href: 'https://www.hangikredi.com/',
  src: '/static/img/brands/hangikredi.png',
  width: 90,
  height: 16
}, {
  href: 'https://www.cimri.com/',
  src: '/static/img/brands/cimri.png',
  width: 40,
  height: 14
}, {
  href: 'https://www.neredekal.com/',
  src: '/static/img/brands/neredekal.png',
  width: 110,
  height: 14
}, {
  href: 'https://tr.steelorbis.com/',
  src: '/static/img/brands/steelorbis.png',
  width: 62,
  height: 27
}, {
  href: 'https://www.chemorbis.com/tr/',
  src: '/static/img/brands/chemorbis.png',
  width: 68,
  height: 27
}, {
  href: 'https://www.endeksa.com/tr/',
  src: '/static/img/brands/endeksa.png',
  width: 85,
  height: 21
}];
/* harmony default export */ __webpack_exports__["a"] = (featuredNewItems);

/***/ })

}]);